<template>
  <div id='footer'>
    <div class='footer_top'>
      <div class='top_text'>
        <img style="width: 24px;height: 24px;" src="../../assets/images/new_logo_small.png">
        <div class='wrap_text'>
          <div
            style='font-size: 14px;font-family: Source Han Sans SC;font-weight: bold;color: #303D5D;margin-top:3px;margin-bottom:10px'>
            山东农业大学植物保护学院&仪器设备共享平台
          </div>
          <div class='text'>
            <div style='display:flex;justify-content: space-between;'>
              <span>邮编：271018</span>
              <span>电话：0538-8247770</span>
              <span>E-Mail：625603892@qq.com</span>
            </div>
            <div>地址：山东省泰安市岱宗大街61号</div>
            <!-- <div>鲁ICP备05002369号 公安机关备号15220601000028号</div> -->
            <div>技术支持：青岛博什兰物联技术有限公司</div>
          </div>
        </div>
      </div>
      <div class='top_image'>
        <img src="../../assets/images/weixin.png" alt="">
        <span>微信公众号</span>
      </div>
    </div>
    <div class='footer_bottom'>
      Copyright©山东农业大学植物保护学院 All Rights Reserved
    </div>
  </div>
</template>
<script>

export default {
  name: 'SDAUfooter',
  data() {
    return {

    }
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
#footer {
  height: 224px;
  min-width: 1400px;

  .footer_top {
    background: #f4f4f4;
    height: 184px;
    padding: 0 448px 0 448px;
    display: flex;
    justify-content: space-between;

    .top_text {
      margin-top: 36px;
      display: flex;
      justify-content: space-between;

      .wrap_text {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 8px;
        height: 108px;

        .text {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          font-size: 14px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          width: 500px;
          color: #303d5d;

        }
      }
    }

    .top_image {
      padding-top: 30px;
      font-size: 14px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #303d5d;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 29px;
    }
  }

  .footer_bottom {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #333333;
    color: #ffffff;
    font-size: 12px;
  }
}
</style>